"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageModule = void 0;
const service_1 = require("./service/service");
class StorageModule {
    constructor(wallet, api) {
        this.service = new service_1.Service(wallet, api);
    }
    /**
     * Get storage balance
     */
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.service.api.getStorageBalance();
        });
    }
    /**
     * @param  {string} amountInGbs Number of gigabytes of storage to purchase
     * @param  {StorageBuyOptions} [options] simulate, confirm, etc.
     */
    buy(amountInGbs, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!options.paymentId) {
                return yield this.service.api.initPayment(amountInGbs, options);
            }
            else {
                return yield this.service.api.confirmPayment(options.paymentId);
            }
        });
    }
}
exports.StorageModule = StorageModule;
;
